export default "__VITE_ASSET__31b03ef6__"